import AttachmentsTab from "./AttachmentsTab";
import ITPTab from "./ITPTab";
import ScopeTab from "./ScopeTab";
import VendorDataRequirements from "./VendorDataTab";

export const navItems = [
  { label: "Scope", panel: <ScopeTab /> },
  { label: "Attachments", panel: <AttachmentsTab /> },
  { label: "Vendor Data Req.", panel: <VendorDataRequirements /> },
  { label: "ITP", panel: <ITPTab /> },
];
